import ClientList from './ClientList';

export default {
  name: 'client',
  list: ClientList,
};
